import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var RequestIcon = function RequestIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e, _f;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height,
    fillColor = _props.fillColor;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.07 17.3",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: fillColor,
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#222"),
    "stroke-linecap": "".concat((_d = attrs["stroke-linecap"]) !== null && _d !== void 0 ? _d : "round"),
    "stroke-linejoin": "".concat((_e = attrs["stroke-linejoin"]) !== null && _e !== void 0 ? _e : "round"),
    "stroke-width": "".concat((_f = attrs["stroke-width"]) !== null && _f !== void 0 ? _f : "1.3")
  }, [h("path", {
    d: "M13.05 8.06V5.613a1.122 1.122 0 0 0-.33-.795L8.881.979A1.125 1.125 0 0 0 8.086.65h-5.28A2.156 2.156 0 0 0 .65 2.805v11.689a2.156 2.156 0 0 0 2.156 2.156h6.89"
  }), h("path", {
    d: "M12.8 5.148H9.678a1.124 1.124 0 0 1-1.127-1.127V.87"
  }), h("path", {
    d: "M5.603 13.388h9.547"
  }), h("path", {
    d: "m12.175 10.417 2.975 2.975"
  }), h("path", {
    d: "m12.175 16.363 2.975-2.975"
  })]));
};